<template>
  <div class="main-content-container">
    <div class="container">
      <!-- Page Header -->
      <div class="page-header row no-gutters py-4">
        <div class="col-6 text-center text-sm-left mb-0">
          <span class="text-uppercase page-subtitle">sessão</span>
          <h3 class="page-title">{{title}}</h3>
        </div>
        <!-- Page Header - Datepicker -->
        <div class="col-6 d-flex">
          <div class="input-group d-flex justify-content-end my-auto">
            <button type="button" class="btn btn-primary btn-sm mt-3" @click="OpenModalFilter()">
              <i class="fas fa-filter"></i>
              {{ countFilter > 0 ? "Filtros aplicados" : "" }}
              <span
                v-if="countFilter > 0"
                class="badge badge-light"
              >{{countFilter}}</span>
            </button>
            <button
              v-if="countFilter > 0"
              type="button"
              class="input-group-text btn-sm ml-1 mt-3"
              v-b-tooltip.hover.bottom
              title="Limpar filtros"
              @click="ResetFilter()"
            >
              <i class="fas fa-eraser"></i>
            </button>
          </div>
        </div>
      </div>

      <!-- Default Light Table -->
      <div class="row">
        <div class="col">
          <div class="card card-small mb-4">
            <div class="card-header border-bottom">
              <div class="float-left">
                <h6 class="m-0">Arquivos</h6>
              </div>
              <div v-if="pagination.TotalItems > 0" class="float-right">
                <h6
                  class="m-0"
                >{{pagination.TotalItems | number}} {{pagination.TotalItems > 1 ? " itens" : "item"}}</h6>
              </div>
            </div>
            <div class="card-body p-0 pb-3 text-center">
              <loader :is-loading="loadingList"></loader>
              <table class="table mb-0" v-if="!loadingList">
                <thead class="bg-s2p-gray-light">
                  <tr>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0 text-left">{{labelDescription}}</th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0"></th>
                    <th scope="col" class="border-0" v-if="$isAuthorize('Document', 'Get')"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(download, index) in downloads" :key="index">
                    <td></td>
                    <td class="text-left">
                      <i :class="[GetIconClass(download.Extension)]"></i>
                      <span>{{download.Description}}</span>
                    </td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td></td>
                    <td v-if="$isAuthorize('Document', 'Get')">
                      <button
                        class="btn btn-outline-secondary"
                        type="button"
                        v-on:click="GetDocument($event, download.Id)"
                        :disabled="loadingDownload && download.Id == idDownload"
                      >
                        <template v-if="!(loadingDownload && download.Id == idDownload)">
                          <i class="fas fa-long-arrow-alt-down mr-1"></i>Download
                        </template>
                        <template v-else>
                          <loader
                            :small="true"
                            :isLoading="loadingDownload && download.Id == idDownload"
                          ></loader>
                        </template>
                      </button>
                    </td>
                  </tr>
                  <tr v-if="downloads == null || downloads == undefined || downloads.length == 0">
                    <td colspan="7">Sem registros</td>
                  </tr>
                </tbody>
              </table>

              <div class="col-12 border-top">
                <div class="pagination-nav">
                  <b-pagination
                    class="float-right"
                    v-model="pagination.PageNumber"
                    :total-rows="pagination.TotalItems"
                    :per-page="pagination.RowsPerPage"
                    aria-controls="my-table"
                  ></b-pagination>
                  <div class="float-left">
                    <d-select size="sm" v-model="pagination.RowsPerPage">
                      <option value="5">5</option>
                      <option value="10">10</option>
                      <option value="30">30</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                      <option value="200">200</option>
                      <option value="500">500</option>
                    </d-select>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <b-modal
      id="mFilter"
      title="Filtros"
      centered
      :no-close-on-backdrop="true"
      :no-close-on-esc="false"
    >
      <d-form-row>
        <d-col md="12" class="form-group">
          <input
            type="text"
            class="form-control"
            v-model="filter.Description"
            :placeholder="labelDescription"
            v-on:keyup.enter="Filter()"
          />
        </d-col>
      </d-form-row>
      <template slot="modal-footer">
        <b-button
          variant="primary"
          class="btn btn-primary"
          v-b-tooltip.hover.bottom
          title="Pesquisar"
          @click="Filter()"
        >
          <i class="fas fa-search"></i>
        </b-button>
        <b-button
          variant="primary"
          class="input-group-text"
          v-b-tooltip.hover.bottom
          title="Limpar filtros"
          @click="ResetFilter()"
        >
          <i class="fas fa-eraser"></i>
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { hasValue } from "../../utils/functions.js";
export default {
  name: "downloads",
  data: function() {
    return {
      title: "Central de Downloads",
      labelDescription: "Arquivo",
      countFilter: 0,
      filter: {
        Description: null
      },
      loadingList: false,
      loadingDownload: false,
      pagination: {
        RowsPerPage: 10,
        PageNumber: 1,
        TotalItems: 0
      },
      idDownload: null,
      downloads: []
    };
  },
  computed: {},
  watch: {
    "pagination.PageNumber": function() {
      this.ListDocument();
    },
    "pagination.RowsPerPage": function() {
      this.ListDocument();
    }
  },
  mounted() {
    this.ListDocument();
  },
  methods: {
    OpenModalFilter: function() {
      this.$bvModal.show("mFilter");
    },
    Filter: function() {
      this.$bvModal.hide("mFilter");
      this.ListDocument();
    },
    ResetFilter: function() {
      this.filter = {
        Description: null
      };
      this.ListDocument();
    },
    GetIconClass: function(extension) {
      let variation = "alt";
      switch (this.$options.filters.lower(extension)) {
        case "bmp":
        case "gif":
        case "jpg":
        case "jpeg":
        case "png":
        case "tif":
          variation = "image";
          break;
        case "csv":
        case "csvx":
          variation = "csv";
          break;
        case "doc":
        case "docx":
          variation = "word";
          break;
        case "pdf":
          variation = "pdf";
          break;
        case "ppt":
        case "pptx":
          variation = "powerpoint";
          break;
        case "xls":
        case "xlsx":
          variation = "excel";
          break;
      }
      return "fas fa-file-" + variation + " mr-1";
    },
    ListDocument: function() {
      this.countFilter = 0;
      if (hasValue(this.filter.Description)) this.countFilter++;
      this.loadingList = true;
      let data = {
        ...this.pagination,
        ...{
          "Object.Description": this.filter.Description,
          CodeApplication: "2"
        }
      };
      delete data.TotalItems;
      this.$store
        .dispatch("ListDocument", { params: data })
        .then(
          response => {
            this.downloads = response.Objects;
            this.pagination.TotalItems = response.TotalItems;
          },
          error => {
            this.$makeToast(
              "Não foi possível listar os arquivos",
              "danger",
              this.title,
              error
            );
          }
        )
        .finally(() => {
          this.loadingList = false;
        });
    },
    GetDocument: function(e, id) {
      e.preventDefault();
      this.loadingDownload = true;
      this.idDownload = id;

      this.$store
        .dispatch("GetDocument", { id: id })
        .then(response => {
          if (hasValue(response.Url)) {
            this.$makeToast(
              "Aguarde a conclusão do download",
              "info",
              this.title
            );
            window.open(response.Url, "_self");
          }
        })
        .catch(error => {
          this.$makeToast(
            "Não foi possível realizar o download do arquivo",
            "danger",
            this.title,
            error
          );
        })
        .finally(() => {
          this.idDownload = null;
          this.loadingDownload = false;
        });
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/pages/downloads.vue